/* PETTIE STUDIO — scripts propios (sin librerías) */
(function () {
  'use strict';
  if (window.__psInit) return; // el archivo se incluye desde varias secciones
  window.__psInit = true;

  function reducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  /* ---------- Aparición suave al hacer scroll ---------- */
  function initReveal() {
    var els = document.querySelectorAll('.ps-reveal');
    if (!els.length) return;
    if (reducedMotion() || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('ps-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('ps-visible'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Menú móvil ---------- */
  function initMenu() {
    var btn = document.querySelector('[data-ps-burger]');
    var menu = document.querySelector('[data-ps-mobile-menu]');
    if (!btn || !menu) return;
    function set(open) {
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      menu.classList.toggle('is-open', open);
    }
    btn.addEventListener('click', function () { set(btn.getAttribute('aria-expanded') !== 'true'); });
    menu.querySelectorAll('a').forEach(function (a) { a.addEventListener('click', function () { set(false); }); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') set(false); });
  }

  /* ---------- Galería de producto (deslizable) ---------- */
  function initGallery() {
    document.querySelectorAll('[data-ps-gal]').forEach(function (gal) {
      var track = gal.querySelector('[data-ps-gal-track]');
      if (!track) return;
      var thumbs = [].slice.call(gal.querySelectorAll('[data-ps-gal-thumb]'));
      var prev = gal.querySelector('[data-ps-gal-prev]');
      var next = gal.querySelector('[data-ps-gal-next]');
      var count = track.children.length;
      var current = 0;
      function go(i) {
        i = Math.max(0, Math.min(count - 1, i));
        track.scrollTo({ left: i * track.clientWidth, behavior: reducedMotion() ? 'auto' : 'smooth' });
      }
      document.addEventListener('ps:gallery-go', function (e) { go(e.detail.index); });
      function mark(i) {
        current = i;
        thumbs.forEach(function (t, k) {
          if (k === i) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current');
        });
        if (prev) prev.disabled = i === 0;
        if (next) next.disabled = i === count - 1;
      }
      var ticking = false;
      track.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          ticking = false;
          var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
          if (i !== current) mark(i);
        });
      }, { passive: true });
      thumbs.forEach(function (t, k) { t.addEventListener('click', function () { go(k); }); });
      if (prev) prev.addEventListener('click', function () { go(current - 1); });
      if (next) next.addEventListener('click', function () { go(current + 1); });
      track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); go(current + 1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); go(current - 1); }
      });
      mark(0);
    });
  }

  /* ---------- Variantes (por si se añaden más adelante) ---------- */
  function initVariants() {
    document.querySelectorAll('[data-ps-product]').forEach(function (root) {
      var json = root.querySelector('[data-ps-variants]');
      var idInput = root.querySelector('[data-ps-variant-id]');
      if (!json || !idInput) return;
      var variants;
      try { variants = JSON.parse(json.textContent); } catch (e) { return; }
      var submit = root.querySelector('[data-ps-submit]');
      var prices = root.querySelectorAll('[data-ps-price]');
      var compares = root.querySelectorAll('[data-ps-compare]');
      var groups = root.querySelectorAll('[data-ps-option]');
      function update() {
        var chosen = [];
        groups.forEach(function (g) {
          var c = g.querySelector('input:checked');
          chosen.push(c ? c.value : null);
        });
        var match = variants.find(function (v) {
          return v.options.every(function (o, i) { return o === chosen[i]; });
        });
        if (!match) { if (submit) submit.disabled = true; return; }
        idInput.value = match.id;
        prices.forEach(function (p) { p.textContent = match.price_formatted; });
        compares.forEach(function (c) {
          if (match.compare_formatted) { c.textContent = match.compare_formatted; c.hidden = false; }
          else { c.hidden = true; }
        });
        if (submit) {
          submit.disabled = !match.available;
          var label = submit.querySelector('[data-ps-submit-label]');
          if (label) label.textContent = match.available ? submit.getAttribute('data-label') : submit.getAttribute('data-label-soldout');
        }
        var url = new URL(window.location.href);
        url.searchParams.set('variant', match.id);
        window.history.replaceState({}, '', url.toString());
      }
      groups.forEach(function (g) { g.addEventListener('change', update); });
    });
  }

  /* ---------- Barra de compra fija en móvil ---------- */
  function initSticky() {
    var bar = document.querySelector('[data-ps-sticky]');
    var target = document.querySelector('[data-ps-form-anchor]');
    if (!bar || !target || !('IntersectionObserver' in window)) return;
    var btn = bar.querySelector('button');
    var io = new IntersectionObserver(function (entries) {
      bar.classList.toggle('is-visible', !entries[0].isIntersecting);
    }, { threshold: 0.01 });
    io.observe(target);
    if (btn) btn.addEventListener('click', function () { target.scrollIntoView({ behavior: 'smooth', block: 'start' }); });
  }

  /* ---------- Subida de fotos: vista previa, límite y compresión ---------- */
  var pendingFiles = 0;

  function compressImage(file) {
    return new Promise(function (resolve) {
      var okType = /^image\/(jpeg|png|webp)$/.test(file.type);
      if (!okType || file.size < 1.2 * 1024 * 1024 || !window.URL || !window.DataTransfer) { resolve(file); return; }
      var img = new Image();
      var url = URL.createObjectURL(file);
      img.onload = function () {
        try {
          var max = 2400;
          var w = img.naturalWidth, h = img.naturalHeight;
          var k = Math.min(1, max / Math.max(w, h));
          var c = document.createElement('canvas');
          c.width = Math.round(w * k);
          c.height = Math.round(h * k);
          c.getContext('2d').drawImage(img, 0, 0, c.width, c.height);
          c.toBlob(function (blob) {
            URL.revokeObjectURL(url);
            if (!blob || blob.size >= file.size) { resolve(file); return; }
            resolve(new File([blob], file.name.replace(/\.[^.]+$/, '') + '.jpg', { type: 'image/jpeg' }));
          }, 'image/jpeg', 0.9);
        } catch (e) { URL.revokeObjectURL(url); resolve(file); }
      };
      img.onerror = function () { URL.revokeObjectURL(url); resolve(file); };
      img.src = url;
    });
  }

  function initFiles() {
    var submit = document.querySelector('[data-ps-submit]');
    var submitLabel = submit ? submit.querySelector('[data-ps-submit-label]') : null;
    var idleLabel = submitLabel ? submitLabel.textContent : '';
    function busy(on) {
      if (!submit) return;
      submit.classList.toggle('is-busy', on);
      submit.setAttribute('aria-busy', on ? 'true' : 'false');
      if (submitLabel) submitLabel.textContent = on ? 'PREPARANDO FOTO…' : idleLabel;
    }

    document.querySelectorAll('[data-ps-file]').forEach(function (box) {
      var input = box.querySelector('input[type=file]');
      var name = box.querySelector('[data-ps-file-name]');
      var thumb = box.querySelector('.ps-file__thumb');
      var err = document.querySelector('[data-ps-file-error]');
      if (!input || !name) return;
      var original = name.textContent;
      var icon = thumb ? thumb.innerHTML : '';
      function reset() { name.textContent = original; box.classList.remove('has-file'); if (thumb) thumb.innerHTML = icon; }
      function show(f) {
        name.textContent = f.name;
        box.classList.add('has-file');
        if (thumb && window.URL && f.type.indexOf('image/') === 0) {
          var img = document.createElement('img');
          img.alt = '';
          img.src = URL.createObjectURL(f);
          thumb.innerHTML = '';
          thumb.appendChild(img);
        }
      }
      input.addEventListener('change', function () {
        var f = input.files && input.files[0];
        if (err) err.hidden = true;
        if (!f) { reset(); return; }
        show(f);
        pendingFiles++;
        busy(true);
        compressImage(f).then(function (small) {
          if (small !== f) {
            try {
              var dt = new DataTransfer();
              dt.items.add(small);
              input.files = dt.files;
            } catch (e) { small = f; }
          }
          if (small.size > 20 * 1024 * 1024) {
            input.value = '';
            if (err) err.hidden = false;
            reset();
          }
        }).then(function () {
          pendingFiles = Math.max(0, pendingFiles - 1);
          if (!pendingFiles) busy(false);
        });
      });
    });

    var form = submit ? submit.form : null;
    if (form) {
      form.addEventListener('submit', function (e) {
        if (pendingFiles > 0) { e.preventDefault(); return; }
        if (submitLabel) submitLabel.textContent = 'AÑADIENDO…';
        submit.classList.add('is-busy');
        submit.setAttribute('aria-busy', 'true');
      });
      window.addEventListener('pageshow', function (e) {
        if (e.persisted) busy(false);
      });
    }
  }

  /* ---------- Carrusel de la portada ---------- */
  function initCarousel() {
    var root = document.querySelector('[data-ps-carousel]');
    if (!root) return;
    var slides = [].slice.call(root.querySelectorAll('[data-ps-slide]'));
    var dots = [].slice.call(root.querySelectorAll('[data-ps-dot]'));
    if (slides.length < 3) return;
    var pos = slides.map(function (s) { return s.getAttribute('data-pos'); });
    var seconds = parseFloat(root.getAttribute('data-interval')) || 0;
    var timer = null;
    function fwd(p) { return p === 'left' ? 'center' : p === 'center' ? 'right' : 'left'; }
    function back(p) { return p === 'left' ? 'right' : p === 'center' ? 'left' : 'center'; }
    function apply() {
      slides.forEach(function (s, i) { s.setAttribute('data-pos', pos[i]); });
      dots.forEach(function (d, i) {
        var on = pos[i] === 'center';
        d.classList.toggle('is-active', on);
        d.setAttribute('aria-current', on ? 'true' : 'false');
      });
    }
    function next() { pos = pos.map(fwd); apply(); }
    function prev() { pos = pos.map(back); apply(); }
    function bring(i) {
      var n = 0;
      while (pos[i] !== 'center' && n < 3) { pos = pos.map(fwd); n++; }
      apply();
    }
    function start() {
      if (!seconds || reducedMotion() || timer) return;
      timer = setInterval(next, seconds * 1000);
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function restart() { stop(); start(); }

    slides.forEach(function (s, i) {
      s.addEventListener('click', function () { if (pos[i] !== 'center') { bring(i); restart(); } });
    });
    dots.forEach(function (d, i) {
      d.addEventListener('click', function () { bring(i); restart(); });
    });

    /* Deslizar con el dedo o el ratón */
    var sx = null, sy = null;
    root.addEventListener('pointerdown', function (e) { sx = e.clientX; sy = e.clientY; stop(); });
    root.addEventListener('pointerup', function (e) {
      if (sx === null) return;
      var dx = e.clientX - sx, dy = e.clientY - sy;
      sx = sy = null;
      if (Math.abs(dx) > 34 && Math.abs(dx) > Math.abs(dy) * 1.2) {
        if (dx > 0) next(); else prev();
      }
      if (e.pointerType !== 'mouse') restart();
    });
    root.addEventListener('pointercancel', function () { sx = sy = null; restart(); });
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', function () { sx = sy = null; start(); });
    document.addEventListener('visibilitychange', function () { if (document.hidden) stop(); else start(); });
    apply();
    start();
  }

  /* ---------- Pasos de "Cómo funciona" ---------- */
  function initSteps() {
    document.querySelectorAll('[data-ps-steps]').forEach(function (root) {
      var steps = [].slice.call(root.querySelectorAll('.ps-step'));
      if (!steps.length) return;
      var i = -1;
      var timer = null;
      function show(n) {
        steps.forEach(function (s, k) { s.classList.toggle('is-active', k === n); });
        i = n;
      }
      function tick() { show((i + 1) % steps.length); }
      function start() {
        if (reducedMotion() || timer) return;
        tick();
        timer = setInterval(tick, 2200);
      }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }
      steps.forEach(function (s, k) {
        s.addEventListener('mouseenter', function () { stop(); show(k); });
        s.addEventListener('mouseleave', function () { start(); });
        s.addEventListener('click', function () { stop(); show(k); });
      });
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          if (entries[0].isIntersecting) start(); else stop();
        }, { threshold: 0.35 }).observe(root);
      } else {
        start();
      }
    });
  }

  /* ---------- Huellitas al tocar o mover el puntero ---------- */
  function initPaws() {
    if (reducedMotion()) return;
    var layer = document.createElement('div');
    layer.className = 'ps-paws';
    layer.setAttribute('aria-hidden', 'true');
    document.body.appendChild(layer);
    var pawSvg = '<svg viewBox="0 0 24 24" fill="currentColor"><ellipse cx="6.2" cy="10.2" rx="2" ry="2.6"/><ellipse cx="10.4" cy="6.2" rx="2" ry="2.7"/><ellipse cx="15.2" cy="6.2" rx="2" ry="2.7"/><ellipse cx="19" cy="10.2" rx="2" ry="2.6"/><path d="M12.6 12c-3 0-6 3.4-6 6 0 1.6 1.4 2.4 3 2.2 1.3-.2 2-.6 3-.6s1.7.4 3 .6c1.6.2 3-.6 3-2.2 0-2.6-3-6-6-6z"/></svg>';
    var last = null;
    var side = 1;
    function spawn(x, y, angle) {
      while (layer.children.length > 12) layer.removeChild(layer.firstChild);
      var el = document.createElement('span');
      el.className = 'ps-paw';
      el.innerHTML = pawSvg;
      el.style.left = x + 'px';
      el.style.top = y + 'px';
      el.style.setProperty('--r', angle + 'deg');
      layer.appendChild(el);
      window.setTimeout(function () { if (el.parentNode) el.parentNode.removeChild(el); }, 1500);
    }
    function move(x, y, gap) {
      if (!last) { last = { x: x, y: y }; return; }
      var dx = x - last.x, dy = y - last.y;
      var d = Math.sqrt(dx * dx + dy * dy);
      if (d < gap) return;
      side = -side;
      var angle = Math.atan2(dy, dx) * 180 / Math.PI + 90;
      spawn(x + (-dy / d) * side * 9, y + (dx / d) * side * 9, angle);
      last = { x: x, y: y };
    }
    document.addEventListener('mousemove', function (e) { move(e.clientX, e.clientY, 72); }, { passive: true });
    document.addEventListener('mouseleave', function () { last = null; });
    document.addEventListener('touchstart', function (e) {
      var t = e.touches[0];
      if (!t) return;
      last = { x: t.clientX, y: t.clientY };
      spawn(t.clientX, t.clientY, Math.round(Math.random() * 40 - 20));
    }, { passive: true });
    document.addEventListener('touchmove', function (e) {
      var t = e.touches[0];
      if (t) move(t.clientX, t.clientY, 58);
    }, { passive: true });
    document.addEventListener('touchend', function () { last = null; }, { passive: true });
  }

  /* ---------- Marca en rojo los campos obligatorios al intentar enviar sin rellenarlos ---------- */
  function initValidation() {
    document.querySelectorAll('.ps-form').forEach(function (form) {
      function wrapOf(el) {
        return el.closest('.ps-file') || el.closest('.ps-options') || el.closest('.ps-field');
      }
      form.querySelectorAll('input, select, textarea').forEach(function (el) {
        el.addEventListener('invalid', function () {
          var w = wrapOf(el);
          if (w) w.classList.add('is-invalid');
          var msg = w && w.querySelector('[data-ps-file-required]');
          if (msg) msg.hidden = false;
        });
        el.addEventListener('input', function () { clear(el); });
        el.addEventListener('change', function () { clear(el); });
      });
      function clear(el) {
        var w = wrapOf(el);
        if (!w) return;
        w.classList.remove('is-invalid');
        var msg = w.querySelector('[data-ps-file-required]');
        if (msg) msg.hidden = true;
      }
    });
  }

  /* ---------- Formato de uso: casillas ligadas a la variante real que fija el precio ---------- */
  function initFormats() {
    document.querySelectorAll('[data-ps-formats]').forEach(function (box) {
      var cbs = [].slice.call(box.querySelectorAll('[data-ps-format-cb]'));
      var hiddenValue = box.querySelector('[data-ps-format-value]');
      var note = box.querySelector('[data-ps-format-note]');
      var reqMsg = box.querySelector('[data-ps-formats-required]');
      var targetName = box.getAttribute('data-target-option');
      var form = box.closest('form');
      var group = null;
      function findGroup() {
        if (!group && form) group = form.querySelector('[data-ps-option][data-option-name="' + targetName + '"]');
        return group;
      }
      function sync() {
        var checked = cbs.filter(function (c) { return c.checked; });
        if (hiddenValue) hiddenValue.value = checked.map(function (c) { return c.value; }).join(', ');
        cbs.forEach(function (c) { c.closest('.ps-formats__item').classList.toggle('is-on', c.checked); });
        if (checked.length > 0) {
          box.classList.remove('is-invalid');
          if (reqMsg) reqMsg.hidden = true;
        }
        var g = findGroup();
        if (g && checked.length > 0) {
          var word = checked.length === 1 ? '1 formato' : checked.length + ' formatos';
          var radio = g.querySelector('input[value="' + word + '"]');
          if (radio && !radio.checked) {
            radio.checked = true;
            radio.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
        if (note) {
          if (checked.length <= 1) {
            note.textContent = '';
          } else {
            var extra = (checked.length - 1) * 1.9;
            note.textContent = checked.length + ' formatos elegidos · suplemento: +' + extra.toFixed(2).replace('.', ',') + ' €';
          }
        }
      }
      cbs.forEach(function (c) { c.addEventListener('change', sync); });
      if (form) {
        form.addEventListener('submit', function (e) {
          var any = cbs.some(function (c) { return c.checked; });
          if (!any) {
            e.preventDefault();
            box.classList.add('is-invalid');
            if (reqMsg) reqMsg.hidden = false;
            box.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        });
      }
      sync();
    });
  }

  /* ---------- Reseñas: reparte las tarjetas en columnas (tipo masonry) sin huecos ---------- */
  function initReviewsMasonry() {
    var grid = document.querySelector('.ps-reviews__grid');
    if (!grid) return;
    var items = Array.prototype.slice.call(grid.children).filter(function (el) {
      return el.classList.contains('ps-review');
    });
    if (!items.length) return;
    var currentCols = 0;
    function layout() {
      var cols = window.innerWidth >= 750 ? 3 : 2;
      if (cols === currentCols) return;
      currentCols = cols;
      var columns = [];
      for (var i = 0; i < cols; i++) {
        var col = document.createElement('div');
        col.className = 'ps-reviews__col';
        columns.push(col);
      }
      items.forEach(function (item, i) {
        columns[i % cols].appendChild(item);
      });
      grid.innerHTML = '';
      columns.forEach(function (col) { grid.appendChild(col); });
      grid.classList.add('is-ready');
    }
    layout();
    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(layout, 150);
    });
  }

  /* ---------- Cuenta atrás de la barra de oferta: ciclo fijo según el reloj, no depende del navegador ---------- */
  function initPromoCountdown() {
    var el = document.querySelector('[data-ps-countdown]');
    if (!el) return;
    var out = el.querySelector('[data-ps-countdown-value]');
    if (!out) return;
    var hours = parseInt(el.getAttribute('data-ps-countdown-hours'), 10) || 48;
    var durationMs = hours * 60 * 60 * 1000;
    var epoch = Date.UTC(2026, 0, 1);
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function tick() {
      var diff = durationMs - ((Date.now() - epoch) % durationMs);
      var h = Math.floor(diff / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      var s = Math.floor((diff % 60000) / 1000);
      out.textContent = pad(h) + ':' + pad(m) + ':' + pad(s);
    }
    tick();
    setInterval(tick, 1000);
  }

  /* ---------- Opción (Rey / Reina) que lleva a su foto de la galería ---------- */
  function initChoiceLinks() {
    document.querySelectorAll('[data-ps-gallery-links]').forEach(function (group) {
      var map = {};
      (group.getAttribute('data-ps-gallery-links') || '').split(',').forEach(function (pair) {
        var kv = pair.split('=');
        if (kv.length === 2) map[kv[0].trim().toLowerCase()] = parseInt(kv[1], 10) - 1;
      });
      group.querySelectorAll('input[type=radio]').forEach(function (r) {
        r.addEventListener('change', function () {
          var idx = map[r.value.trim().toLowerCase()];
          if (idx >= 0) document.dispatchEvent(new CustomEvent('ps:gallery-go', { detail: { index: idx } }));
        });
      });
    });
  }

  /* ---------- Comparador antes / después ---------- */
  function initCompare() {
    document.querySelectorAll('[data-ps-cmp]').forEach(function (root) {
      var frame = root.querySelector('[data-ps-cmp-frame]');
      var range = root.querySelector('[data-ps-cmp-range]');
      var stages = [].slice.call(root.querySelectorAll('[data-ps-cmp-stage]'));
      var tabs = [].slice.call(root.querySelectorAll('[data-ps-cmp-tab]'));
      if (!frame || !stages.length) return;
      function setPos(p) {
        p = Math.max(0, Math.min(100, p));
        frame.style.setProperty('--pos', p + '%');
        if (range) range.value = Math.round(p);
      }
      function fromEvent(e) {
        var r = frame.getBoundingClientRect();
        setPos(((e.clientX - r.left) / r.width) * 100);
      }
      var dragging = false;
      frame.addEventListener('pointerdown', function (e) {
        dragging = true;
        try { frame.setPointerCapture(e.pointerId); } catch (err) {}
        fromEvent(e);
      });
      frame.addEventListener('pointermove', function (e) { if (dragging) fromEvent(e); });
      function end() { dragging = false; }
      frame.addEventListener('pointerup', end);
      frame.addEventListener('pointercancel', end);
      if (range) range.addEventListener('input', function () { setPos(parseFloat(range.value)); });

      function loadAll() {
        stages.forEach(function (s) {
          s.querySelectorAll('img[data-src]').forEach(function (img) {
            img.src = img.getAttribute('data-src');
            img.removeAttribute('data-src');
          });
        });
      }
      function show(i) {
        stages.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
        tabs.forEach(function (t, k) {
          t.classList.toggle('is-active', k === i);
          t.setAttribute('aria-selected', k === i ? 'true' : 'false');
        });
        var ratio = stages[i].getAttribute('data-ratio');
        if (ratio) frame.style.setProperty('--ps-cmp-ratio', ratio);
        setPos(50);
      }
      tabs.forEach(function (t, k) {
        t.addEventListener('click', function () { loadAll(); show(k); });
        t.addEventListener('pointerenter', loadAll, { once: true });
        t.addEventListener('focus', loadAll, { once: true });
      });
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          if (entries[0].isIntersecting) { window.setTimeout(loadAll, 800); io.disconnect(); }
        }, { rootMargin: '200px' });
        io.observe(frame);
      } else { loadAll(); }
    });
  }

  function init() {
    initReveal();
    initMenu();
    initGallery();
    initVariants();
    initSticky();
    initFiles();
    initCarousel();
    initSteps();
    initPaws();
    initValidation();
    initFormats();
    initPromoCountdown();
    initReviewsMasonry();
    initChoiceLinks();
    initCompare();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
